import script from "./splitpanes.vue?vue&type=script&lang=js"
export * from "./splitpanes.vue?vue&type=script&lang=js"

import "./splitpanes.vue?vue&type=style&index=0&id=0b589747&lang=scss"

export default script